/**
 * @module ナビゲーション部共通コンポーネント
 */
export default {
  data() {
    return {
      displayDistrictFlag: false,
      cameraFlag: false,
      isLoggedIn: false,
    };
  },
  props: {
    isHomeSecurityHover: {
      type: Boolean,
      default: false,
      required: false,
    },
    isCameraHover: {
      type: Boolean,
      default: false,
      required: false,
    },
    isNewMainUserHover: {
      type: Boolean,
      default: false,
      required: false,
    },
    isNotificationHover: {
      type: Boolean,
      default: false,
      required: false,
    },
    isTempMainUserRegistrationHover: {
      type: Boolean,
      default: false,
      required: false,
    },
    isUserRegistrationHover: {
      type: Boolean,
      default: false,
      required: false,
    },
    isTermsHover: {
      type: Boolean,
      default: false,
      required: false,
    },
    isPrivacyHover: {
      type: Boolean,
      default: false,
      required: false,
    },
    isApprovalTermsHover: {
      type: Boolean,
      default: false,
      required: false,
    },
    isLicenseHover: {
      type: Boolean,
      default: false,
      required: false,
    },
    isContactHover: {
      type: Boolean,
      default: false,
      required: false,
    },
    isSettingsHover: {
      type: Boolean,
      default: false,
      required: false,
    },
    isServiceAddHover: {
      type: Boolean,
      default: false,
      required: false,
    },
    // isLoggedIn: {
    //   type: Boolean,
    //   default: false,
    //   required: false,
    // },
    responseAPP_CO9916: {
      type: Function,
      default: () => {},
      require: false,
    },
    propsDisplayDistrictFlag: {
      type: Boolean,
      default: true,
      required: false,
    },
    propsCameraFlag: {
      type: Boolean,
      default: true,
      required: false,
    },
    propsSettinOnlyFlag: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  mounted() {
    this.isLoggedIn = this.$store.getters['isLoggedIn'];
  },
  /** @type {Methods} */
  methods: {
    /**
     * 通知履歴遷移前設定処理
     */
    goNotificationHistory: function () {
      this.$store.commit('setFromType', { fromType: 0 });
    },
    // APP_CO9916: async function () {
    //   this.$_setLoading(true);
    //   let param = "/api/common/getRoleList";
    //   // let param = "post";
    //   let queries = {
    //     token: sessionStorage.getItem("token"),
    //     terminalInfo: localStorage.getItem("terminalInfo")
    //       ? localStorage.getItem("terminalInfo")
    //       : "",
    //   };
    //   let method = "post";
    //   let apiData = "";
    //   await this.$store
    //     .dispatch(`requestApi/${method}ApiInfoAction`, {
    //       url: param,
    //       params: queries,
    //     })
    //     .then(
    //       (response /* eslint-disable-line */) => {
    //         apiData = response;
    //         // サンプルデータ
    //         // apiData = {
    //         //   contentsInfo: {
    //         //     displayDistrictInfoList: [
    //         //       {
    //         //         customerNumber: "customerNumber1",
    //         //         districtSplitNumber: "districtSplitNumber1",
    //         //         existsSecurityArea: false,
    //         //         displayDistrictUserType: 1,
    //         //         userAuthority: {
    //         //           securityOperation: true,
    //         //           rushOrder: false,
    //         //           notificationHistory: false,
    //         //           deviceContorol: false,
    //         //           contact: false,
    //         //           nicknameSetting: false,
    //         //           IDCardKeyInfoSetting: false,
    //         //           watchOverInfoDeliverySetting: false,
    //         //           lockUpCheck: false,
    //         //           targetAtHomeSetting: false,
    //         //           userManagement: false,
    //         //           emergencyContact: false,
    //         //         },
    //         //       },
    //         //       {
    //         //         customerNumber: "customerNumber2",
    //         //         districtSplitNumber: "districtSplitNumber2",
    //         //         existsSecurityArea: false,
    //         //         displayDistrictUserType: 1,
    //         //         userAuthority: {
    //         //           securityOperation: true,
    //         //           rushOrder: false,
    //         //           notificationHistory: false,
    //         //           deviceContorol: false,
    //         //           contact: false,
    //         //           nicknameSetting: false,
    //         //           IDCardKeyInfoSetting: false,
    //         //           watchOverInfoDeliverySetting: false,
    //         //           lockUpCheck: false,
    //         //           targetAtHomeSetting: false,
    //         //           userManagement: false,
    //         //           emergencyContact: false,
    //         //         },
    //         //       },
    //         //       {
    //         //         customerNumber: "customerNumber3",
    //         //         districtSplitNumber: "districtSplitNumber3",
    //         //         existsSecurityArea: false,
    //         //         displayDistrictUserType: 1,
    //         //         userAuthority: {
    //         //           securityOperation: false,
    //         //           rushOrder: false,
    //         //           notificationHistory: false,
    //         //           deviceContorol: false,
    //         //           contact: false,
    //         //           nicknameSetting: false,
    //         //           IDCardKeyInfoSetting: false,
    //         //           watchOverInfoDeliverySetting: false,
    //         //           lockUpCheck: false,
    //         //           targetAtHomeSetting: false,
    //         //           userManagement: false,
    //         //           emergencyContact: false,
    //         //         },
    //         //       },
    //         //       {
    //         //         customerNumber: "customerNumber4",
    //         //         districtSplitNumber: "districtSplitNumber4",
    //         //         existsSecurityArea: false,
    //         //         displayDistrictUserType: 1,
    //         //         userAuthority: {
    //         //           securityOperation: false,
    //         //           rushOrder: false,
    //         //           notificationHistory: false,
    //         //           deviceContorol: false,
    //         //           contact: false,
    //         //           nicknameSetting: false,
    //         //           IDCardKeyInfoSetting: false,
    //         //           watchOverInfoDeliverySetting: false,
    //         //           lockUpCheck: false,
    //         //           targetAtHomeSetting: false,
    //         //           userManagement: false,
    //         //           emergencyContact: false,
    //         //         },
    //         //       },
    //         //       {
    //         //         customerNumber: "customerNumber5",
    //         //         districtSplitNumber: "districtSplitNumber5",
    //         //         existsSecurityArea: true,
    //         //         displayDistrictUserType: 1,
    //         //         userAuthority: {
    //         //           securityOperation: false,
    //         //           rushOrder: false,
    //         //           notificationHistory: false,
    //         //           deviceContorol: false,
    //         //           contact: false,
    //         //           nicknameSetting: false,
    //         //           IDCardKeyInfoSetting: false,
    //         //           watchOverInfoDeliverySetting: false,
    //         //           lockUpCheck: false,
    //         //           targetAtHomeSetting: false,
    //         //           userManagement: false,
    //         //           emergencyContact: false,
    //         //         },
    //         //       },
    //         //     ],
    //         //     cameraInfoList: [
    //         //       {
    //         //         customerNumber: "customerNumber",
    //         //         districtSplitNumber: "districtSplitNumber",
    //         //         deviceID: "deviceID",
    //         //         cameraUserType: 0,
    //         //         userAuthority: {
    //         //           anticrimeCameraVideos: true,
    //         //           rushOrder: false,
    //         //           notificationHistory: false,
    //         //           contact: false,
    //         //           nicknameSetting: false,
    //         //           userManagement: false,
    //         //           emergencyContact: false,
    //         //         },
    //         //       },
    //         //     ],
    //         //   },
    //         // };
    //         if (apiData.contentsInfo) {
    //           this.displayDistrictFlag = false;
    //           apiData.contentsInfo.displayDistrictInfoList.forEach(
    //             (displayDistrictInfo) => {
    //               if (
    //                 displayDistrictInfo.userAuthority.securityOperation ==
    //                   true ||
    //                 displayDistrictInfo.userAuthority.rushOrder == true ||
    //                 displayDistrictInfo.userAuthority.notificationHistory ==
    //                   true ||
    //                 displayDistrictInfo.userAuthority.deviceContorol == true ||
    //                 displayDistrictInfo.userAuthority.contact == true ||
    //                 displayDistrictInfo.userAuthority.nicknameSetting == true ||
    //                 displayDistrictInfo.userAuthority.IDCardKeyInfoSetting ==
    //                   true ||
    //                 displayDistrictInfo.userAuthority
    //                   .watchOverInfoDeliverySetting == true ||
    //                 displayDistrictInfo.userAuthority.lockUpCheck == true ||
    //                 displayDistrictInfo.userAuthority.targetAtHomeSetting ==
    //                   true ||
    //                 displayDistrictInfo.userAuthority.userManagement == true ||
    //                 displayDistrictInfo.userAuthority.emergencyContact == true
    //               ) {
    //                 this.displayDistrictFlag = true;
    //                 return true;
    //               }
    //             }
    //           );
    //           this.cameraFlag = false;
    //           apiData.contentsInfo.cameraInfoList.forEach((cameraInfo) => {
    //             if (
    //               cameraInfo.userAuthority.anticrimeCameraVideos == true ||
    //               cameraInfo.userAuthority.rushOrder == true ||
    //               cameraInfo.userAuthority.notificationHistory == true ||
    //               cameraInfo.userAuthority.contact == true ||
    //               cameraInfo.userAuthority.nicknameSetting == true ||
    //               cameraInfo.userAuthority.userManagement == true ||
    //               cameraInfo.userAuthority.emergencyContact == true
    //             ) {
    //               this.cameraFlag = true;
    //               return true;
    //             }
    //           });
    //           this.responseAPP_CO9916(apiData);
    //         }
    //       },
    //       (error /* eslint-disable-line */) => {
    //         // ToDo 異常系の処理については、FE-CU2_共通項目を参照。
    //       }
    //     )
    //     .finally(() => {
    //       this.$_setLoading(false);
    //     });
    //   // console.log("APP_CU9916>>>", apiData);
    // },
  },
};
